/*eslint-disable*/
import React from "react";
// nodejs library to set properties for components
import PropTypes from "prop-types";
// nodejs library that concatenates classes
import classNames from "classnames";
// material-ui core components
import {List, ListItem} from "@material-ui/core";
import {makeStyles} from "@material-ui/core/styles";
import Button from "components/CustomButtons/Button.js";
import Tooltip from "@material-ui/core/Tooltip";


// @material-ui/icons
import Favorite from "@material-ui/icons/Favorite";

// import styles from "assets/jss/material-kit-pro-react/components/footerStyle.js";
import styles from "assets/jss/material-kit-pro-react/views/componentsSections/footerStyle.js";

// import {dangerColor, primaryColor} from "../../assets/jss/material-kit-react";
import CustomDropdown from "../../components/CustomDropdown/CustomDropdown";
import {Apps, CloudDownload} from "@material-ui/icons";
import {Link} from "react-router-dom";
import BaseBottomItem from "./BaseBottomItem";
import GridItem from "../../components/Grid/GridItem";
import Footer from "../../components/Footer/Footer";
import GridContainer from "../../components/Grid/GridContainer";
import CustomInput from "../../components/CustomInput/CustomInput";
import intl from "react-intl-universal";


const useStyles = makeStyles(styles);

export default function BaseFooter(props) {
	const classes = useStyles();
	const {whiteFont, router} = props;
	const footerClasses = classNames({
		[classes.footer]: true,
		[classes.footerWhiteFont]: whiteFont
	});
	const aClasses = classNames({
		[classes.a]: true,
		[classes.footerWhiteFont]: whiteFont
	});

	return (
		<Footer
			theme="dark"
			content={
				<div className={classes.right}>
					<List className={classes.list}>
						<ListItem className={classes.listItem}>
							<ListItem className={classes.listItem}>
								Copyright © 惊开软件技术工作室 保留一切权利&nbsp;&nbsp;
								<a href={"http://beian.miit.gov.cn/"}
								   className={aClasses}
								   target={"_blank"}><i><u>沪ICP备20021908号</u></i></a>
							</ListItem>

						</ListItem>
					</List>
				</div>
			}
		>
			<div className={classes.footer}>
				<GridContainer>
					<GridItem xs={12} sm={2} md={2}>
						<h5 style={{color: '#fff'}}>RobinAlgo</h5>
						<ul className={classes.linksVertical}>
							<li>
								<a href="/welcome">
									{intl.get('welcome')}
								</a>
							</li>
							<li>
								<a href="/series">
									{intl.get('series')}
								</a>
							</li>
							<li>
								<a href="/plan">
									{intl.get('subscription')}
								</a>
							</li>
							<li>
								<a href="/question">
									{intl.get('about')}
								</a>
							</li>
						</ul>
					</GridItem>

					<GridItem xs={12} sm={2} md={2}>
						<h5 style={{color: '#fff'}}>{intl.get('about')}</h5>
						<ul className={classes.linksVertical}>
							<li>
								<a href="https://github.com/clwater" target={'_blank'}
								   style={{textTransform: 'none'}}>GitHub</a>
							</li>
							<li>
								<a href="https://www.gengzhibo.com/" target={'_blank'}
								   style={{textTransform: 'none'}}>Blog</a>
							</li>
						</ul>
					</GridItem>

					<GridItem xs={12} sm={2} md={2}>
						<h5 style={{color: '#fff'}}>{intl.get('down_app')}</h5>
						<ul className={classes.linksVertical}>
							<li>
								<a href="/androidDownload" target={'_blank'}
								   style={{textTransform: 'none'}}>{intl.get('down_android')}</a>
							</li>
						</ul>
					</GridItem>

					<GridItem xs={12} sm={4} md={4}>
						<h5 style={{color: '#fff'}}>{intl.get('contact_us')}</h5>
						<div className={classes.galleryFeed}>

							<img
								className={classNames(
									classes.img,
									classes.imgRaised,
									// classes.imgRounded
								)}
								style={{width: '100px'}}
								src={'https://robinalgo.oss-cn-shanghai.aliyuncs.com/images/robinalgo_wechat_avatar.jpg'}/>
							<img
								src={'https://robinalgo.oss-cn-shanghai.aliyuncs.com/images/gongzhonghao.jpg'}
								className={classNames(
									classes.img,
									classes.imgRaised,
								)}
								style={{width: '100px'}}
							/>
						</div>
					</GridItem>

				</GridContainer>
			</div>
		</Footer>
	);
}

BaseFooter.propTypes = {
	whiteFont: PropTypes.bool,
	router: PropTypes.object
};
